import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DaModal = ({ show, handleClose, selectedWorkspaceId, workspaceName, daValue,onSave }) => {
  const [userList, setUserList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUserId, setSelectedUserId] = useState(daValue || ''); // Store only a single selected user ID
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    if (show) {
      axios.get('https://stage-apiplatform.finkraft.ai/api/meta/users')
        .then((response) => {
          if (response.data.status) {
            setUserList(response.data.data);
          }
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
        });
    }
  }, [show]);

  const handleUserSelection = (userId) => {
    setSelectedUserId(userId); // Set only one selected user ID
  };

  const handleSave = () => {
    if (!selectedUserId) {
      alert('Please select a user.');
      return;
    }

    // Call your API here to save the single userId against the workspaceId
    axios.post('https://stage-apiplatform.finkraft.ai/api/meta/user/update', {
      id : selectedWorkspaceId,
      userId: selectedUserId,  // Sending a single user ID
      type: 'da'               // Specify the type as 'da'
    },{
      headers: {
          'Authorization': `Bearer ${token}`
      }
  })
    .then(response => {
      console.log('User ID saved successfully:', response.data);
      onSave(selectedUserId);
      handleClose(); // Close the modal after saving
    })
    .catch(error => {
      console.error('Error saving user ID:', error);
    });
  };

  const filteredUserList = userList.filter(user => 
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (!show) return null; // Return null if the modal should not be shown

  return (
    <div className="modal-overlay">
      <div className="modal-content-da">
        <h2>DA of Workspace: {workspaceName}</h2>
        <input 
          type="text" 
          placeholder="Search users..." 
          value={searchTerm} 
          onChange={(e) => setSearchTerm(e.target.value)} 
          className='da-search-input'
        />
        <div style={{ maxHeight: '300px', overflowY: 'scroll', marginTop: '10px' }}>
          {filteredUserList.length > 0 ? (
            filteredUserList.map(user => (
              <div key={user.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <input 
                  type="radio" 
                  id={user.id} 
                  name="user" 
                  checked={selectedUserId === user.id} // Checked if it's the selected user ID
                  onChange={() => handleUserSelection(user.id)} // Set selected user ID
                />
                <label htmlFor={user.id}>{user.name}</label>
              </div>
            ))
          ) : (
            <p>No users found.</p>
          )}
        </div>
        <div style={{ marginTop: '20px' }}>
          <button onClick={handleClose}>Back</button>
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default DaModal;
